import { render, staticRenderFns } from "./UpdateInstruments.vue?vue&type=template&id=395b1004&scoped=true"
import script from "./UpdateInstruments.vue?vue&type=script&lang=js"
export * from "./UpdateInstruments.vue?vue&type=script&lang=js"
import style0 from "./UpdateInstruments.vue?vue&type=style&index=0&id=395b1004&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395b1004",
  null
  
)

export default component.exports